import {Component, OnInit, ViewChild} from '@angular/core';
import {Ordered} from '../../models/ordered';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {OrderedService} from '../../services/ordered.service';

import {ActivatedRoute, Router} from '@angular/router';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';

import {AnnuityPayDialogComponent} from '../dialogs/annuity-pay-dialog/annuity-pay-dialog.component';
import {ProductLotService} from 'src/app/services/product-lot.service';
import {ProductCatPriceService} from 'src/app/services/product-cat-price.service';
import {MemberService} from 'src/app/services/member.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {AnnuityViewerDialogComponent} from '../dialogs/annuity-viewer-dialog/annuity-viewer-dialog.component';
import {FileService} from 'src/app/services/file.service';

@Component({
  selector: 'app-annuity-report',
  templateUrl: './annuity-report.component.html',
  styleUrls: [ './annuity-report.component.scss' ]
})
export class AnnuityReportComponent implements OnInit {

  public payedDataSource: MatTableDataSource<any>;
  // public displayedPayedColumns: string[] = [ 'date', 'member_name', 'Tid', 'installments', 'discount', 'original', 'value', 'total', 'tax', 'total_minus_tax', 'edit', 'delete' ];
  public displayedPayedColumns: string[] = [ 'date', 'member_name', 'Tid', 'installments', 'discount', 'original', 'value', 'total', 'total_minus_tax', 'edit', 'delete' ];
  

  public notPayedDataSource: MatTableDataSource<any>;
  public displayedNotPayedColumns: string[] = [ 'icon', 'member', 'subCategory_name', 'annuity_from', 'value' ];

  public totalOrdered: number = 0;
  public totalOrdered_minus_tax: number = 0;
  public countOrdered: number = 0;

  public countPayed: number = 0;
  public countNotPayed: number = 0;

  public totalPayed: number = 0;
  public totalNotPayed: number = 0;

  public annuity_id: string;
  public annuity_name: string;
  public annuity_from: number = 0;

  public subCategoriesAndValues: any[] = [];
  public allOrders: any = []

  public waitingMany: any

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public membersWhoPay: any = []
  public memberCatNotPay: any = []

  constructor (
    private db: AngularFirestore,
    public _orderedService: OrderedService,
    public _memberService: MemberService,
    private snackBar: SnackBarIconService,
    private _productLotService: ProductLotService,
    private _productCatPriceService: ProductCatPriceService,
    private route: ActivatedRoute,
    private router: Router,
    private _spinnerService: SpinnerService,
    private dialog: MatDialog,
    private _fileService: FileService,
  ) {
    let annuity_data = this.route.snapshot.paramMap.get('id');
    let parts = annuity_data.split(":");
    this.annuity_id = parts[ 0 ]
    this.annuity_name = parts[ 1 ]
    this.annuity_from = parts[ 2 ] ? Number(parts[ 2 ]) : 0

    //console.log('this.annuity_from: ' + this.annuity_from)

    this.loadOrdered();

    this.loadProductLots()
  }

  ngOnInit () {
  }

  applyFilter (filterValue: string) {
    this.payedDataSource.filter = filterValue.trim().toLowerCase();
  }

  loadOrdered () {

    const waiting = this._spinnerService.show();

    return this.db.collection<any>('sbccv_orders', ref => ref
      .where('product_id', '==', this.annuity_id)
      .orderBy('date', 'desc')).snapshotChanges()
      .subscribe((orders) => {

        this.allOrders = [];

        orders.forEach((order) => {

          if (order.payload.doc.data().returnCode == "00" && order.payload.doc.data().member_name) {

            this.totalOrdered += order.payload.doc.data().total ? Number(order.payload.doc.data().total) : 0
            this.totalOrdered_minus_tax += order.payload.doc.data().total_minus_tax ? Number(order.payload.doc.data().total_minus_tax) : 0
            this.countOrdered += 1

            let o: any = this._orderedService.createOrderObj(order) //Orders
            //console.log(o.discount)
            this.allOrders.push(o)
          }

        })

        this.payedDataSource = new MatTableDataSource(this.allOrders)
        this.payedDataSource.sort = this.sort;

        waiting.close()

      })

  }

  openDeleteDialog (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.product_name + "<br><br>" + element.member_name + "<br><br>Excluir esta inscrição?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        const waiting = this._spinnerService.show();
        this._orderedService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
              waiting.close()
            }
          )
          .catch(
            (error) => {console.log("delete order error: ")}
          )

      }
    })
  }

  openViewerDialog (entity) {

    //console.log("annuity_id: " + this.annuity_id)
    // console.log("annuity_name: " + this.annuity_name)
    console.log("entity:  " + JSON.stringify(entity))
    const product: any = {'id': this.annuity_id, 'name': this.annuity_name}

    let data: Ordered = new Ordered();

    if (entity) {
      data = entity;
    }

    this.dialog.open(AnnuityViewerDialogComponent, {
      width: '800px',
      height: '565px',
      panelClass: 'custom-dialog-container',
      data: {'product': product, 'ordered': data}
    });
  }

  openPayDialog (entity) {
    const product: any = {'id': this.annuity_id, 'name': this.annuity_name}

    let data: Ordered = new Ordered();

    if (entity) {
      data = entity;
    }

    this.dialog.open(AnnuityPayDialogComponent, {
      width: '800px',
      height: '640px',
      panelClass: 'custom-dialog-container',
      data: {'product': product, 'ordered': data}
    });

  }

  formatDate (date: Date) {
    if (date) {
      let dt = date.toISOString()
      let dd: any = dt.substr(8, 2);
      let mm: any = dt.substr(5, 2);
      let yy: any = dt.substr(0, 4);
      return dd + "/" + mm + "/" + yy
    } else {
      return ""
    }
  }

  goBack () {
    this.router.navigate([ 'annuity' ]);
  }

  loadProductLots () {
    this.waitingMany = this._spinnerService.show();

    this._productLotService.loadLots(this.annuity_id)
      .subscribe((result) => {
        result.forEach((item) => {
          //console.log("lot_id: " + item.id)
          const lot_id = item.id

          //escolher o lote vigente
          this.loadProductCatPrice(lot_id)

        })
      })


  }

  loadProductCatPrice (lot_id) {

    this._productCatPriceService.loadLotCatPrices(lot_id)
      .subscribe((result) => {

        result.forEach((item) => {

          const categories = item.data().categories

          categories.forEach((cat) => {

            this.subCategoriesAndValues.push({
              'subCategory_id': cat.id,
              'subCategory_name': cat.name,
              'value': item.data().value,
              'value_defaulting': item.data().value_defaulting
            })

          })

        })

        // console.log(JSON.stringify(this.subCategoriesAndValues))

        this.loadMembersWhoPayAnnuities()
      })

  }

  loadMembersWhoPayAnnuities () {
    console.log('loadMembersWhoPayAnnuities')

    this.membersWhoPay = []
    this.memberCatNotPay = []

    this._memberService.load()
      .subscribe((result) => {
        result.forEach((item) => {

          if (item.data().deleted !== true) {

            if (item.data().subCategory) {

              const member_subCategory_id = item.data().subCategory.id

              const subCat = this.subCategoriesAndValues.find((e) => {
                return e.subCategory_id == member_subCategory_id
              })

              if (subCat) {
                let _annuity_from: number = 0
                if (!item.data().annuity_from) {
                  _annuity_from = new Date().getFullYear()
                  //console.log("_annuity_from: " + _annuity_from)
                  //console.log(item.data().name)
                } else {
                  _annuity_from = Number(item.data().annuity_from)
                }

                this.membersWhoPay.push({
                  'id': item.id,
                  'name': item.data().name,
                  'cpf': item.data().cpf,
                  'subCategory_id': item.data().subCategory.id,
                  'subCategory_name': item.data().subCategory.name,
                  'annuity_from': _annuity_from,
                  'value': subCat.value,
                  'value_defaulting': 'value_defaulting',
                  'regional': item.data().regional,
                  'city': item.data().city,
                  'state': item.data().state,
                  'situation': item.data().situation
                })

              } else {
                this.memberCatNotPay.push({
                  'id': item.id,
                  'name': item.data().name,
                  'subCategory_id': item.data().subCategory.id,
                  'subCategory_name': item.data().subCategory.name,
                })
              }

            }

          }
        })

        this.payOrNotPay(this.membersWhoPay)
      })
  }

  payOrNotPay (membersWhoPay: any[]) {
    // console.log(JSON.stringify(membersWhoPay))

    //const annuitiesPayed: any = []
    const annuitiesNotPayed: any = []

    this.countPayed = 0;
    this.countNotPayed = 0;

    membersWhoPay.forEach((memberItem) => {
      /*
      console.log(memberItem.id)
      console.log(memberItem.name)
      console.log("-------------------------------------")
      */

      const existAnnuity = this.allOrders.find((e) => {
        return (e.member_id == memberItem.id)
          && (e.product_id == this.annuity_id)
      })

      if (existAnnuity) {
        //annuitiesPayed.push(existAnnuity)
        this.countPayed++
        this.totalPayed += existAnnuity.value
      } else {

        //console.log("this.annuity_from: " + this.annuity_from)
        //console.log("memberItem.annuity_from: " + memberItem.annuity_from)
        //console.log("-----------------------------------------")

        // if ( memberItem.annuity_from >= this.annuity_from) {

        if (memberItem.annuity_from <= this.annuity_from) {

          // console.log("member: " + memberItem.name)
          // console.log("annuity_from: " + memberItem.annuity_from)

          annuitiesNotPayed.push(memberItem)
          this.countNotPayed++
          this.totalNotPayed += memberItem.value

        }

      }

    })

    /*
    console.log()
    console.log("annuity_id: " + this.annuity_id)
    console.log()
    console.log("countPayed: " + this.countPayed)
    console.log("countNotPayed: " + this.countNotPayed)
    console.log()
    console.log("totalPayed: " + this.totalPayed)
    console.log("totalNotPayed: " + this.totalNotPayed)
    */

    //this.payedAnnuityDataSource = new MatTableDataSource(annuitiesPayed)
    this.notPayedDataSource = new MatTableDataSource(annuitiesNotPayed)

    this.waitingMany.close()

  }

  exportCSV () {

    const data: any = this.payedDataSource.data
    //console.log('membersWhoPay: ' + JSON.stringify(this.membersWhoPay))
    //console.log('payedDataSource.data: ' + JSON.stringify(data))

    data.sort(this.compareNames)

    let csvFile: any[] = []

    csvFile.push("" + ";" + this.annuity_name + '\r\n')

    let csvHeader: string;
    csvHeader = "" + ";"
    csvHeader += 'Data' + ';'
    csvHeader += 'Data PG' + ';'
    csvHeader += 'Nome' + ';'
    csvHeader += 'Situação' + ';'
    csvHeader += 'CPF' + ';'
    csvHeader += 'Categoria Pgto' + ';'
    csvHeader += 'Categoria Atual' + ';'
    csvHeader += 'Regional' + ';'
    csvHeader += 'Cidade' + ';'
    csvHeader += 'Estado' + ';'
    csvHeader += 'Origem' + ';'
    csvHeader += 'TipoPgto' + ';'
    csvHeader += 'Documento' + ';'

    csvHeader += 'Desconto' + ';'
    csvHeader += 'Débito' + ';'
    csvHeader += 'Original' + ';'
    csvHeader += 'X' + ';'
    csvHeader += 'Valor' + ';'
    csvHeader += 'Total' + ';'
    //csvHeader += 'Taxa' + ';'
    csvHeader += 'Liguido' + '\r\n'

    csvFile.push(csvHeader)

    data.forEach((line) => {

      const member: any = this.membersWhoPay.find((e) => {
        return e.id === line.member_id
      })

      let memberCatNotPay: any = []

      if (!member) {
        memberCatNotPay = this.memberCatNotPay.find((e) => {
          return e.id == line.member_id
        })
      }

      let situation: string = ''

      if (member) {
        switch (member.situation.toString()) {
          case '0':
            situation = "Quite"
            break
          case '1':
            situation = "Não-Quite"
            break
          case '2':
            situation = "Isento"
            break
        }
      }

      let dtFormated = new Date(line.date.seconds * 1000)
      let dtPgFormated = line.payDate

      let csvLine: string;
      csvLine = "" + ";"
      csvLine += this.formatDate(dtFormated) + ";"
      csvLine += this.formatDate(dtPgFormated) + ";"
      csvLine += line.member_name + ";"
      csvLine += situation + ";"
      csvLine += member ? member.cpf + ";" : line.member_cpf + ";"
      csvLine += line.category_name + ";"
      csvLine += member ? member.subCategory_name + ";" : memberCatNotPay.subCategory_name + ";"
      //member
      csvLine += member ? member.regional + ";" : "" + ";"
      csvLine += member ? member.city + ";" : "" + ";"
      csvLine += member ? member.state + ";" : "" + ";"
      csvLine += line.origin + ";"
      csvLine += line.payment_type + ";"
      csvLine += line.Tid + ";"

      csvLine += line.discount ? line.discount.toString().replace('.', ',') + ";" : "0" + ";"
      csvLine += line.member_debit ? line.member_debit.toString().replace('.', ',') + ";" : "0" + ";"
      csvLine += line.rawValue ? line.rawValue.toString().replace('.', ',') + ";" : "0" + ";"
      
      csvLine += line.installments ? (line.installments + ";") : ("1" + ";");

      csvLine += line.value ? line.value.toString().replace('.', ',') + ";" : "0" + ";"
      csvLine += line.total ? line.total.toString().replace('.', ',') + ";" : "0" + ";"
      //csvLine += line.tax ? line.tax + ";": "0" + ";"
      csvLine += line.total_minus_tax ? line.total_minus_tax.toString().replace('.', ',') + "\r\n" : "0" + "\r\n"

      csvFile.push(csvLine)

    })

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});
    this._fileService.saveFile(blob, "Relatório_" + this.annuity_name + ".csv");

  }

  compareNames (a, b) {
    const pa = String(a.member_name)
    const pb = String(b.member_name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;

  }
}
